import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

/**
 * Pipe to check if the signed in User is in specified system role.
 *
 * @export
 * @class HasRoleGuard
 * @implements {CanActivate}
 */
@Injectable({
  providedIn: 'root'
})
export class HasRoleGuard implements CanActivate {
  /**
   * Creates an instance of HasRoleGuard.
   *
   * @param {AuthorizeService} authorize Authorisation service.
   * @param {Router} router Angular router service.
   * @memberof HasRoleGuard
   */
  constructor(
    private authService: AuthService,
    private readonly router: Router
  ) {
  }

  /**
   * Checks whether the current User has the system role specified.
   *
   * @param {ActivatedRouteSnapshot} route Angular active route snapshot.
   * @param {RouterStateSnapshot} state Angular route state snapshot.
   * @return {*}
   * @memberof HasRoleGuard
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.userRole$.pipe(
      filter(role => role !== null),
      take(1),
      map(role => {
        if (role && route.data.allowedRoles && route.data.allowedRoles.indexOf(role) > -1) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
